export const ROOT_PROJECT = "project-documents";
export const ROOT_SYSTEM = "system-documents";

export const DOC_STATUS = {
  Missing: "Missing",
  Pending: "Pending",
  Approved: "Approved",
  Rejected: "Rejected",
};

export const DOC_STATUS_LABEL = {
  Missing: "Yok",
  Pending: "Bekliyor",
  Approved: "Onaylı",
  Rejected: "Red",
};

export const COMPLIANCE_STATUS = {
  Compliant: "Compliant",
  NonCompliant: "NonCompliant",
};

export const ALLOWED_EXTENSIONS = ["pdf", "jpg", "jpeg", "png", "webp"];
export const MAX_FILE_BYTES = 20 * 1024 * 1024;
export const DEFAULT_PAGE_SIZE = 20;
export const ADMIN_PROJECT_ID = 1;
export const PROJECT_DOCUMENTS_LOCKED = "PROJECT_DOCUMENTS_LOCKED";

export const DMS_ROUTE_PATHS = [
  "/documents/categories",
  "/documents/system",
  "/documents/project-tracking",
  "/my-documents",
];
